<!-- Top Nav Bar -->
<nav
  class="h-14 border-b flex items-center justify-end px-6 shadow-sm"
  [class.bg-white]="!backgroundColor"
  [class.border-slate-100]="!dark"
  [class.border-white/10]="dark"
  [style.backgroundColor]="backgroundColor || null"
>
  <div class="flex items-center w-full gap-3 relative">
    <div *ngIf="showBrand" class="flex items-center gap-3 min-w-0">
      <img [src]="brandLogoSrc" [alt]="brandAlt" class="h-24 w-54 sm:h-16 sm:w-56" />
    </div>

    <div class="ml-auto flex items-center gap-4 relative">
    <!-- Notifications -->
     @if (currentUser) {
      <div class="relative" data-notification-menu>
       <button
         type="button"
         (click)="toggleNotifications()"
         class="relative p-2 rounded-full transition-all duration-200"
         [class.text-slate-400]="!dark"
         [class.hover:text-teal-600]="!dark"
         [class.hover:bg-teal-50]="!dark"
         [class.text-white/90]="dark"
         [class.hover:bg-white/10]="dark"
         aria-label="Notifications">
         <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
           <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
             d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
         </svg>
         @if (unreadNotificationCount > 0) {
          <span class="absolute -top-1 -right-1 min-w-5 h-5 px-1 rounded-full bg-red-600 text-white text-[10px] leading-5 text-center font-bold border-2 border-white">
            {{ unreadNotificationCount > 99 ? '99+' : unreadNotificationCount }}
          </span>
         }
       </button>

       <div
        class="absolute right-0 mt-2 w-[360px] max-w-[calc(100vw-2rem)] bg-white rounded-xl border border-slate-100 shadow-xl overflow-hidden z-50 origin-top-right transition-all duration-150"
        [class.hidden]="!notificationOpen">
        <div class="flex items-center justify-between gap-3 px-4 py-3 border-b border-slate-100">
          <div>
            <p class="text-sm font-semibold text-slate-800">Notifications</p>
            <p class="text-xs text-slate-400 mt-0.5">{{ unreadNotificationCount }} unread</p>
          </div>
          <button
            type="button"
            class="text-xs font-semibold text-teal-700 hover:text-teal-800 disabled:text-slate-300"
            [disabled]="unreadNotificationCount === 0"
            (click)="markAllNotificationsRead($event)"
          >
            Mark all read
          </button>
        </div>

        <div class="max-h-96 overflow-y-auto">
          @if (isLoadingNotifications) {
            <div class="px-4 py-8 text-center text-sm text-slate-500">
              Loading notifications...
            </div>
          } @else if (!notifications.length) {
            <div class="px-4 py-8 text-center">
              <p class="text-sm font-medium text-slate-600">No notifications</p>
              <p class="text-xs text-slate-400 mt-1">Workflow updates will appear here.</p>
            </div>
          } @else {
            @for (notification of notifications; track notification.id) {
              <button
                type="button"
                class="w-full text-left px-4 py-3 border-b border-slate-100 hover:bg-slate-50 transition-colors"
                [class.bg-teal-50]="!notification.read"
                (click)="markNotificationRead(notification, $event)"
              >
                <div class="flex items-start gap-3">
                  <span
                    class="mt-1 size-2 rounded-full flex-shrink-0"
                    [class.bg-teal-600]="!notification.read"
                    [class.bg-transparent]="notification.read"
                  ></span>
                  <span class="min-w-0 flex-1">
                    <span class="block text-sm font-semibold text-slate-800 leading-5">
                      {{ notification.title || 'Workflow notification' }}
                    </span>
                    <span class="block text-xs text-slate-500 leading-5 mt-0.5">
                      {{ notification.message }}
                    </span>
                    <span class="block text-[11px] text-slate-400 mt-1">
                      {{ formatNotificationTime(notification.createdAt) }}
                    </span>
                  </span>
                  @if (!notification.read) {
                    <span class="text-[11px] font-semibold text-teal-700 whitespace-nowrap">Mark read</span>
                  }
                </div>
              </button>
            }
          }
        </div>
      </div>
      </div>
     }
      <span *ngIf="!isAdmin" class="text-white font-semibold">
        {{ currentUser?.name ?? '' }}
      </span>
	    <!-- Avatar + Dropdown wrapper -->
	    <div class="relative" data-profile-menu>
	      <!-- <button
	        id="avatarBtn"
	        type="button"
        (click)="toggleDropdown()"
        class="w-9 h-9 rounded-full flex items-center justify-center text-sm font-semibold transition-colors duration-200 shadow-sm"
        [class.bg-teal-600]="!dark"
        [class.hover:bg-teal-700]="!dark"
        [class.text-white]="!dark"
        [class.bg-white]="dark"
        [class.text-teal-700]="dark"
        [class.hover:bg-white/90]="dark"
        aria-haspopup="true" aria-expanded="false">
        {{ initials }}
      </button> -->

      <div class="flex items-center gap-2 cursor-pointer" (click)="toggleDropdown()">
        <button
          id="avatarBtn"
          type="button"
          class="size-9 bg-vms-bg-secondary text-vms-text-secondary rounded-full flex items-center justify-center text-sm font-semibold transition-colors duration-200 shadow-sm"
          aria-haspopup="true" aria-expanded="false">
          {{ initials }}
        </button>
        <svg width="7" height="5" viewBox="0 0 7 5" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.0705 4.51196L0.110816 0.812348C-0.15109 0.484966 0.0819967 0 0.50125 0H6.42063C6.83988 0 7.07296 0.484966 6.81106 0.812348L3.85137 4.51196C3.65121 4.76216 3.27067 4.76216 3.0705 4.51196Z" fill="#595A69"/>
        </svg>
      </div>

      <!-- Dropdown -->
      <div
        id="profileDropdown"
        class="absolute right-0 mt-2 w-56 bg-white rounded-xl border border-slate-100 shadow-lg overflow-hidden z-50 origin-top-right transition-all duration-150"
        [class.hidden]="!dropdownOpen">

        <!-- Header -->
        <div class="px-4 py-3 border-b border-slate-100">
          <p class="text-sm font-semibold text-slate-800">{{ currentUser?.name ?? 'User' }}</p>
          <p class="text-xs text-slate-400 mt-0.5">{{ currentUser?.email ?? '' }}</p>
        </div>

        <!-- Items -->
        <div class="py-1.5">
          <button
            type="button"
            (click)="openProfile()"
            class="flex items-center gap-3 w-full px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 transition-colors"
          >
            <!-- User icon -->
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
            Profile
          </button>
          @if (isMdaAdmin) {
            <button
              type="button"
              (click)="openSettings()" 
              class="flex items-center gap-3 w-full px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 transition-colors">
              <!-- Settings icon -->
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
              Settings
            </button>
          }
          <!-- <button class="flex items-center gap-3 w-full px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 transition-colors" aria-haspopup="true" aria-expanded="false"> -->
            <!-- Help icon -->
            <!-- <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
            Help & support
          </button> -->

          <div class="my-1.5 border-t border-slate-100"></div>

          <button class="flex items-center gap-3 w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"  (click)="logout()">
            <!-- Logout icon -->
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/></svg>
            Log out
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
</nav>

@if (profileOpen) {
  <app-user-profile-modal
    [open]="profileOpen"
    (close)="closeProfile()"
  ></app-user-profile-modal>
}

@if (settingsOpen) {
  <app-mda-settings-modal
    [open]="settingsOpen"
    [targetMdaId]="mdaId"
    (close)="closeSettings()"
  ></app-mda-settings-modal>
}
